<template>
  <div class="form-module">
    <p class="module-title">{{ $locale("rules.theaterAdvTicketInvitationTicket") }}</p>
    <div class="key-block">
      <div class="block-r">
        <div class="clearfix">

          <el-row>
            <el-col :xs="8" :sm="10" :md="12" :lg="12">

              <el-form-item :label="$locale('rules.notAvailableTicketInvitationTicket_multi')" style="width:100%;">
                <el-select v-model="form.unAdvanceCouponTypeIds" multiple filterable @change="handleChange">
                  <MultiSelect :list.sync="form.unAdvanceCouponTypeIds" :dataList="advanceCouponTypeList" useType="all" />
                  <!-- <el-option class="multiControl" value="" @click.native="handleOption">
                    <el-row :gutter="30">
                      <el-col :span="8" :offset="2"  style="text-align:center" class="egl-btn-white">
                        <div @click="handleAll" styel="width:100%">{{ $locale('global.selectAll') }}</div>
                      </el-col>
                      <el-col :offset="4" :span="8" style="text-align:center" class="egl-btn-white">
                        <div @click="handleNone"  styel="width:100%">{{ $locale('global.deselectAll') }}</div>
                      </el-col>
                    </el-row>
                  </el-option> -->
                  <el-option value="all" label="すべてのバージョン"></el-option>
                  <el-option
                    :disabled="form.unAdvanceCouponTypeIds.includes('all')"
                    v-for="item in advanceCouponTypeList"
                    :label="item.name"
                    :value="item.id"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>

            </el-col>
          </el-row>

        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.multiControl {
  height: 36px;
}
</style>

<script>
import MultiSelect from "@/components/common/MultiSelect";
export default {
  name: "ruleTemplateCouponTypeModule",
  data() {
    return {
      form: {
        unAdvanceCouponTypeIds: [],
      },
    };
  },
  props: {
    formObj: {
      type: Object,
      default: () => {},
    },
    advanceCouponTypeList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    MultiSelect,
  },
  watch: {
    formObj() {
      this.form = { unAdvanceCouponTypeIds: [ ...this.formObj.ticketRule.unAdvanceCouponTypeIds ] };
    },
  },
  methods: {
    handleOption(e) {
      this.form.unAdvanceCouponTypeIds.splice(this.form.unAdvanceCouponTypeIds.length-1)
    },
    handleAll(e) {
      let array = []
      this.advanceCouponTypeList.map(item => {
        array.push(item.id)
      })
      this.form.unAdvanceCouponTypeIds = array
    },
    handleNone(e) {
      this.form.unAdvanceCouponTypeIds = []
    },
    handleChange(e) {
      if (e.includes('all')) {
        this.form.unAdvanceCouponTypeIds = ['all'];
      }
    },
  },
};
</script>
